<template>
  <div class="page-container">
    <md-dialog-system-barcode :md-active.sync="systemBarCodeModal" />
    <md-app md-waterfall md-scrollbar>
      <md-app-toolbar class="md-primary main-header">
        <div class="md-toolbar-row">
          <router-link
            :to="{ name: 'home' }"
            tag="a"
            class="md-title"
            style="background-color: var(--md-theme-default-primary, #448aff)"
          >
            <span class="md-list-item-text">Склад</span>
          </router-link>

          <div style="flex: 1"></div>

          <div>
            <md-button
              v-if="scroll"
              v-on:click.prevent="scrollTo"
              class="md-icon-button md-small-hide md-button-custom md-primary md-raised"
            >
              <md-icon>keyboard_arrow_down</md-icon>
            </md-button>

            <md-button
              v-if="scroll"
              v-on:click.prevent="scrollTo"
              class="md-icon-button md-small-hide md-button-custom md-primary md-raised"
            >
              <md-icon>keyboard_arrow_down</md-icon>
            </md-button>

            <md-button
              v-on:click.prevent="systemBarButton"
              class="md-icon-button md-small-hide md-button-custom md-raised md-accent"
            >
              <md-icon>code</md-icon>
            </md-button>

            <md-button
              v-on:click.prevent="changeTheme"
              class="md-icon-button md-small-hide md-button-custom md-accent md-raised"
            >
              <md-icon>color_lens</md-icon>
            </md-button>

            <md-button
              v-if="sound === 'default' || sound === true"
              v-on:click.prevent="funnySound"
              class="md-icon-button md-small-hide md-button-custom md-raised md-accent"
            >
              <md-icon>volume_up</md-icon>
            </md-button>

            <md-button
              v-if="sound === 'funny'"
              v-on:click.prevent="offSound"
              class="md-icon-button md-small-hide md-button-custom md-raised md-accent"
            >
              <md-icon>android</md-icon>
            </md-button>

            <md-button
              v-if="sound === 'off' || sound === false"
              v-on:click.prevent="defaultSound"
              class="md-icon-button md-small-hide md-button-custom md-raised md-primary"
            >
              <md-icon>volume_off</md-icon>
            </md-button>
<!--            <router-link-->
<!--                v-if="$root.auth.apiKey"-->
<!--                :to="{ name: 'inventory' }"-->
<!--                class="md-button-custom md-primary"-->
<!--                tag="md-button"-->
<!--            >-->
<!--              <md-icon>playlist_add_check_circle</md-icon>-->
<!--              <span class="md-small-hide">Переучет</span>-->
<!--            </router-link>-->

            <router-link
              v-if="$root.auth.apiKey"
              :to="{ name: 'home' }"
              class="md-button-custom md-primary"
              tag="md-button"
            >
              <md-icon>shopping_cart</md-icon>
              <span class="md-small-hide">Вложения</span>
            </router-link>

            <router-link
              v-if="$root.auth.apiKey"
              :to="{ name: 'receptions' }"
              class="md-button-custom md-primary"
              tag="md-button"
            >
              <md-icon>local_shipping</md-icon>
              <span class="md-small-hide">Приемка</span>
            </router-link>

            <router-link
              v-if="$root.auth.apiKey"
              :to="{ name: 'leftovers' }"
              class="md-button-custom md-primary"
              tag="md-button"
            >
              <md-icon>restaurant_menu</md-icon>
              <span class="md-small-hide">Остатки</span>
            </router-link>

<!--            <router-link-->
<!--              v-if="$root.auth.apiKey"-->
<!--              :to="{ name: 'replacements' }"-->
<!--              class="md-button-custom md-primary"-->
<!--              tag="md-button"-->
<!--            >-->
<!--              <md-icon>change_history</md-icon>-->
<!--              <span class="md-small-hide">Замены</span>-->
<!--            </router-link>-->

            <md-button
              v-if="!socket.isConnected"
              class="md-icon-button md-small-hide md-button-custom md-raised md-accent"
            >
              <md-icon>close</md-icon>
            </md-button>

            <md-button
              v-if="socket.isConnected && !socket.isRegistered"
              class="md-icon-button md-small-hide md-button-custom md-raised md-accent"
            >
              <md-icon>autorenew</md-icon>
            </md-button>

            <md-button
              v-if="socket.isConnected && socket.isRegistered"
              class="md-icon-button md-small-hide md-button-custom md-raised md-accent"
            >
              <md-icon>wifi</md-icon>
            </md-button>

            <md-button
              v-if="$root.auth.apiKey"
              class="md-icon-button md-button-custom"
              @click="menuVisible = !menuVisible"
            >
              <md-icon>menu</md-icon>
            </md-button>
          </div>
        </div>
      </md-app-toolbar>

      <md-app-drawer
        class="md-right drawer-custom"
        :md-active.sync="menuVisible"
      >
        <md-list>
<!--          <router-link :to="{ name: 'inventory' }" tag="md-list-item">-->
<!--            <md-icon>playlist_add_check_circle</md-icon>-->
<!--            <span v-if="$root.auth.apiKey" class="md-list-item-text">-->
<!--              Переучет-->
<!--            </span>-->
<!--          </router-link>-->

          <router-link :to="{ name: 'home' }" tag="md-list-item">
            <md-icon>shopping_cart</md-icon>
            <span v-if="$root.auth.apiKey" class="md-list-item-text">
              Вложения
            </span>
          </router-link>

          <router-link :to="{ name: 'receptions' }" tag="md-list-item">
            <md-icon>local_shipping</md-icon>
            <span v-if="$root.auth.apiKey" class="md-list-item-text">
              Приемка
            </span>
          </router-link>

          <router-link :to="{ name: 'leftovers' }" tag="md-list-item">
            <md-icon>restaurant_menu</md-icon>
            <span v-if="$root.auth.apiKey" class="md-list-item-text">
              Остатки
            </span>
          </router-link>

<!--          <router-link :to="{ name: 'replacements' }" tag="md-list-item">-->
<!--            <md-icon>change_history</md-icon>-->
<!--            <span v-if="$root.auth.apiKey" class="md-list-item-text">-->
<!--              Замены-->
<!--            </span>-->
<!--          </router-link>-->

          <md-list-item v-if="$root.auth.apiKey" v-on:click.prevent="reset()">
            <md-icon>restore_page</md-icon>
            <span class="md-list-item-text">Сброс</span>
          </md-list-item>

          <router-link
            v-if="$root.auth.apiKey"
            :to="{ name: 'about' }"
            tag="md-list-item"
          >
            <md-icon>info</md-icon>
            <span class="md-list-item-text">О приложении</span>
          </router-link>

          <md-list-item
            v-if="$root.auth.apiKey"
            tag="md-list-item"
            v-on:click.prevent="logout()"
          >
            <md-icon>remove</md-icon>
            <span class="md-list-item-text">
              {{ $root.auth.username }} - Выход
            </span>
          </md-list-item>
        </md-list>

        <div class="drawer-footer show-mobile">
          <md-button
            v-if="scroll"
            v-on:click.prevent="scrollTo"
            class="md-icon-button md-button-custom md-primary md-raised"
          >
            <md-icon>keyboard_arrow_down</md-icon>
          </md-button>

          <md-button
            v-if="scroll"
            v-on:click.prevent="scrollTo"
            class="md-icon-button md-button-custom md-primary md-raised"
          >
            <md-icon>keyboard_arrow_down</md-icon>
          </md-button>

          <md-button
            v-on:click.prevent="systemBarButton"
            class="md-icon-button md-button-custom md-raised md-accent"
          >
            <md-icon>code</md-icon>
          </md-button>

          <md-button
            v-on:click.prevent="changeTheme"
            class="md-icon-button md-button-custom md-accent md-raised"
          >
            <md-icon>color_lens</md-icon>
          </md-button>

          <md-button
            v-if="sound === 'default' || sound === true"
            v-on:click.prevent="funnySound"
            class="md-icon-button md-button-custom md-raised md-accent"
          >
            <md-icon>volume_up</md-icon>
          </md-button>

          <md-button
            v-if="sound === 'funny'"
            v-on:click.prevent="offSound"
            class="md-icon-button md-button-custom md-raised md-accent"
          >
            <md-icon>android</md-icon>
          </md-button>

          <md-button
            v-if="sound === 'off' || sound === false"
            v-on:click.prevent="defaultSound"
            class="md-icon-button md-button-custom md-raised md-primary"
          >
            <md-icon>volume_off</md-icon>
          </md-button>

          <md-button
            v-if="!socket.isConnected"
            class="md-icon-button md-button-custom md-raised md-accent"
          >
            <md-icon>close</md-icon>
          </md-button>

          <md-button
            v-if="socket.isConnected && !socket.isRegistered"
            class="md-icon-button md-button-custom md-raised md-accent"
          >
            <md-icon>autorenew</md-icon>
          </md-button>

          <md-button
            v-if="socket.isConnected && socket.isRegistered"
            class="md-icon-button md-button-custom md-raised md-accent"
          >
            <md-icon>wifi</md-icon>
          </md-button>
        </div>
      </md-app-drawer>

      <md-app-content id="content" class="app-content">
        <router-view :key="$route.fullPath"></router-view>
      </md-app-content>
    </md-app>

    <md-drawer :class="drawler" :md-active.sync="showModal">
      <ExtendedShowProduct></ExtendedShowProduct>
    </md-drawer>

    <md-dialog-confirm
      :md-active.sync="confirmResetShow"
      md-title="Вы в самом деле хотите сбросить загруженные заказы?"
      md-content="После сброса заказов их нужно заново выгрузить в 1С"
      md-confirm-text="О да"
      md-cancel-text="О нет"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
    <md-dialog-alert
      v-if="popup"
      :md-active.sync="popupVisible"
      :md-title="popup.title"
      :md-content="popup.message"
      md-confirm-text="Ну ок"
    />
  </div>
</template>

<script>
  import ExtendedShowProduct from "./components/ExtendedShowProduct";

  export default {
    name: "App",
    components: { ExtendedShowProduct },
    data: () => ({
      systemBarCodeModal: false,
      menuVisible: false,
      popupVisible: false,
      showModal: false,
      confirmResetShow: false,
    }),
    computed: {
      socket() {
        return this.$store.state.websocket.item;
      },
      message() {
        return this.$store.state.messages.messages[this.messages.length - 1];
      },
      messages() {
        return this.$store.state.messages.messages;
      },
      product() {
        return this.$store.state.product.item;
      },
      tab() {
        return this.$store.state.tab.item;
      },
      scroll() {
        return this.$store.state.scroll.item;
      },
      drawler() {
        return this.$store.state.drawler.item;
      },
      popup() {
        return this.$store.state.popup.item;
      },
      sound() {
        return this.$store.state.sounds.sound;
      },
      audio() {
        return this.$store.state.sounds.audio;
      },
      theme() {
        return this.$store.state.themes.theme;
      },
    },
    watch: {
      message() {
        this.$toastr(
          this.message.type,
          this.message.message,
          this.message.code
        );
        if (this.sound === "funny") {
          try {
            this.audio[this.message.type].play();
          } catch (err) {
            console.error(err);
          }
        }

        if (this.sound === "default") {
          try {
            this.audio.default.play();
          } catch (err) {
            console.error(err);
          }
        }
      },
      popup() {
        if (this.popup) {
          this.popupVisible = true;
        }
      },
      popupVisible(newData, oldData) {
        if (true === oldData && false === newData) {
          this.$store.commit("popup/unsetPopup");
        }
      },
      product: function () {
        this.showModal = !!this.product;
      },
      showModal(to, from) {
        if (!to) {
          this.$store.commit("product/unsetProduct");
        }
      },
    },
    created() {
      const audio = {
        error: new Audio("../../audio/error.mp3"),
        warning: new Audio("../../audio/warning.mp3"),
        success: new Audio("../../audio/success.mp3"),
        info: new Audio("../../audio/info.mp3"),
        default: new Audio("../../audio/default.mp3"),
      };

      this.$store.commit("sounds/setAudio", audio);

      window.addEventListener("orientationchange", this.doOnOrientationChange);

      this.doOnOrientationChange();
      this.getUserProfiles();
    },
    methods: {
      getUserProfiles() {
        this.$axios.get("/user_profiles").then((response) => {
          this.$store.commit("profiles/setProfiles", response.data);
        });
      },
      systemBarButton() {
        this.systemBarCodeModal = true;
      },
      logout: function () {
        this.$root.logout();
        this.menuVisible = false;
      },
      scrollTo() {
        document.getElementById("content").scrollIntoView();
      },
      doOnOrientationChange() {
        switch (window.orientation) {
          case -90:
          case 90:
            this.$store.commit("drawler/setDrawler", "land");
            break;
          default:
            this.$store.commit("drawler/setDrawler", "port");
            break;
        }
      },
      reset() {
        this.confirmResetShow = true;
      },
      onConfirm() {
        this.$store.commit("resetData");
        this.$store.commit("messages/setMessage", {
          type: "success",
          code: "О да!",
          message: "Загруженые заказы успешно сброшены",
        });
        this.confirmResetShow = false;
      },
      onCancel() {
        this.value = "Disagreed";
        this.confirmResetShow = false;
      },
      defaultSound() {
        this.$store.commit("sounds/setSound", "default");
      },
      funnySound() {
        this.$store.commit("sounds/setSound", "funny");
      },
      offSound() {
        this.$store.commit("sounds/setSound", "off");
      },
      changeTheme() {
        if (this.theme === "defaultDark") {
          this.$store.commit("themes/setTheme", "default");
        } else {
          this.$store.commit("themes/setTheme", "defaultDark");
        }
      },
    },
  };
</script>

<style lang="scss">
  .main-header {
    z-index: 999 !important;
  }
  body {
    height: 100%;
  }
  .page-container {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
  }
  .md-app {
    height: 100%;
  }

  .app-content {
    @media (max-width: 960px) {
      padding: 0 !important;
    }
  }
  .toast-container {
    font-size: 14px;

    & > div.toast-error {
      background-image: none !important;
    }

    & > div {
      padding: 4px 4px 4px 16px !important;
      width: 200px !important;

      font-size: 12px;
      opacity: 1 !important;
      box-shadow: none;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;

      & .toast-message {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
  } }
  .land {
    width: 80% !important;
    @media (max-width: 800px) {
      width: 80% !important;
    }
  }
  .port {
    width: 66% !important;
    @media (max-width: 800px) {
      width: 80% !important;
    }
  }
  .md-button.md-button-custom {
    margin: 6px 8px !important;
    min-width: 40px !important;
    @media (max-width: 800px) {
      margin: 4px !important;
    }
  }

  .drawer-custom {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .show-mobile {
    display: none;
  }

  @media (max-width: 800px) {
    .show-mobile {
      display: block;
    }
  }

  .drawer-footer {
    padding: 8px;
  }
</style>
